/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export class StartIdNowUserInput {
	skipIdNow?: boolean
}